const angular = require('angular');

const { pagingComponentDefinition } = require('./paging.component');

angular.module('oly.common')
    .component('olyPaging', pagingComponentDefinition);



// WEBPACK FOOTER //
// ./src/olycommon/paging/index.js